import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';
import { jsx as _jsx } from "react/jsx-runtime";
const Header = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("thead", {
    ref: ref,
    children: /*#__PURE__*/_jsx(Row, {
      children: React.Children.map(children, child =>
      /*#__PURE__*/
      // TO DO: pass type as a variant instead of prop
      React.cloneElement(child, {
        type: 'heading'
      }))
    })
  });
});
Header.displayName = 'Header';
Header.propTypes = {
  children: PropTypes.node
};
export default Header;